<template>
  <div class="app-header">
    <div class="app-header__column app-header__column--left"></div>
    <div class="app-header__column app-header__column--center">
      <router-link to="/" class="app-logo">{{ _app.name }}</router-link>
    </div>
    <div class="app-header__column app-header__column--right">
      <a-dropdown v-if="_user.isLoggedIn" :trigger="['click']">
        <a>
          {{ _user.fullName }}
          <a-icon type="down"/>
        </a>
        <a-menu slot="overlay">
          <a-menu-item @click.native="logout()">Logout</a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$auth.logout({
        makeRequest: false,
        success: function() {},
        error: function() {},
        redirect: "/login"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.app-header {
  display: flex;
  align-items: center;
  height: 70px;
  box-shadow: 0 1px 0 0 $color-base-border;
  position: relative;
  z-index: 100;
  flex-shrink: 0;

  &__column {
    flex-basis: 0;
    flex: 1 1 0;
    display: flex;
    padding: 0 25px;

    &--right {
      justify-content: flex-end;
    }
    &--left {
      justify-content: flex-start;
    }
    &--center {
      justify-content: center;
    }
  }
}

.app-logo {
  text-transform: uppercase;
  font-weight: 900;
  font-size: 30px;
  text-decoration: none;
  color: $--color-black;
}
</style>
